import {
    Navigate,
  } from 'react-router-dom';
  
  export function PrivateRoute({ children }){
    let  userid = JSON.parse(sessionStorage.getItem("loginDetails"))?.tenantID !== null ? true : false;
    
    return (
      <>
        {userid !==null 
          ? children
          : <Navigate to="/login"/>
        }
      </>
    );
  }